module.exports = __webpack_public_path__ + "static/media/mobileSearch.b8c3a278.svg";